import type { Canvas, StaticCanvas, FabricObject } from 'fabric';

// A plain util over `getObjects()` rather than a `fabric.Canvas.prototype` monkey-patch — no prototype
// pollution, and typed.
const getItemsByName = (
  canvas: Canvas | StaticCanvas,
  name: string,
): FabricObject[] =>
  canvas.getObjects().filter((object) => object.name === name);

export default getItemsByName;
